export default __webpack_public_path__ + "static/media/jiri-drazny.2f122f95.jpg";